var multiSearch = {
    $element: $('.multi-search'),

    init: function () {
        this.toggle.init(this.$element);
    },
    toggle: {
        $button: false,
        $items: false,
        init: function (parent) {
            this.$button = parent.find('.js--show-more');
            this.$items = parent.find('.js--toggle');

            if (this.$button.length) this.control();
        },
        control: function () {
            var self = this;
            self.$button.on('click', function () {
                self.toggleExpanded();
            });
        },
        toggleExpanded: function () {
            this.setExpanded(!this.isExpanded());
        },
        isExpanded: function () {
            return this.$button.attr('aria-expanded') === 'true';
        },
        setExpanded: function (val) {
            var altIcon = this.$button.data('alt-icon');
            var $i = this.$button.find('i');
            if (val) {
                this.$button.attr('aria-expanded', 'true');
                this.$items.slideDown();
                if ($i.length && altIcon !== '') {
                    $i.addClass(altIcon);
                }
                this.$button.find('span').text('See Less');
            } else {
                this.$button.attr('aria-expanded', 'false');
                this.$items.slideUp();
                if ($i.length && altIcon !== '') {
                    $i.removeClass(altIcon);
                }
                this.$button.find('span').text('See More');
            }
        },
    },
};

UX.multiSearch = multiSearch;
